import React, { ChangeEvent, FC, HTMLAttributes } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCircle } from '@fortawesome/pro-solid-svg-icons';
import styles from './styles.module.scss';
import { c } from '../../../lib/util';

interface CheckboxProps {
    checked?: boolean,
    label?: string | JSX.Element,
    name?: string,
    onChange?: (data: any, e: ChangeEvent<HTMLInputElement>) => void,
    radio?: boolean,
    required?: boolean,
    toggle?: boolean,
}

const Checkbox: FC<CheckboxProps & HTMLAttributes<HTMLInputElement>> = ({
    checked,
    label,
    name,
    onChange,
    radio,
    toggle,
    ...props
}): JSX.Element => {
    const id = `checkbox-${Math.random() * 9999}`;

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange({
                files: e.currentTarget.files,
                name: e.currentTarget.name,
                value: e.currentTarget.checked,
            }, e);
        }
    }

    return (
        <div
            className={c([
                toggle ? styles.toggle : styles.base,
                radio && styles.radio,
            ])}
        >
            {!toggle && <FontAwesomeIcon icon={radio ? faCircle : faCheck} />}
            <input
                checked={checked === true}
                id={id}
                name={name}
                onChange={handleChange}
                type={radio ? 'radio' : 'checkbox'}
                {...props}
            />
            <label htmlFor={id}>{label}</label>
        </div>
    );
}

export default Checkbox;
